export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-fill text-primary-500 text-lg"></i>
              </span>
              <span className="text-base font-heading text-foreground-50">夜猫影院</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              夜猫影院致力于为广大影迷提供最新电影在线看、高清电影播放服务。深夜追剧不卡顿，热门电影推荐每日更新，打造属于深夜观影爱好者的电影大全免费平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '深夜专题', href: '#index' },
                { label: '热映榜单', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '观众评价', href: '#comments' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-100 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-500">敬请期待</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-100 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="hover:text-primary-400 transition-colors cursor-pointer">
                <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5"><i className="ri-mail-line text-xs"></i></span>
                投稿联系
              </a>
              <span>
                <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5"><i className="ri-time-line text-xs"></i></span>
                每日 20:00 更新
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 夜猫影院 — 深夜观影，高清不卡顿
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供交流学习，影片版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}